// extracted by mini-css-extract-plugin
export default {"main":"History_main__UzBBT"};